import type { Mail, PhoneNumber } from "~domain/global/models/coordinates-model.ts";
import type {
  PhoneDto,
  SubscriberEmailAddress,
  SubscriberReadModel,
} from "~infrastructure/.generated/hey/backoffice-backend";

import {
  type Subscriber,
  type SubscriberCompanyId,
  type SubscriberId,
  type SubscriberMail,
  type SubscriberMailId,
  SubscriberMyVoltalisAccess,
  type SubscriberPhone,
  type SubscriberPhoneId,
} from "~domain/subscribers/models/subscriber-model.ts";

class SubscriberMapperCls {
  fromBackofficeMailToDomain(backofficeMail: SubscriberEmailAddress): SubscriberMail {
    return {
      id: backofficeMail.id as SubscriberMailId,
      mail: backofficeMail.mail as Mail,
      valid: backofficeMail.valid === true,
    };
  }

  fromBackofficePhoneToDomain(backofficePhone: PhoneDto): SubscriberPhone {
    return {
      id: backofficePhone.id as SubscriberPhoneId,
      phone: backofficePhone.phone as PhoneNumber,
      valid: backofficePhone.valid === true,
    };
  }

  fromBackofficeSubscriberToDomain(backofficeSubscriber: SubscriberReadModel | null): Subscriber | undefined;
  fromBackofficeSubscriberToDomain(backofficeSubscriber: null): undefined;
  fromBackofficeSubscriberToDomain(backofficeSubscriber: SubscriberReadModel): Subscriber;
  fromBackofficeSubscriberToDomain(backofficeSubscriber: SubscriberReadModel | null): Subscriber | undefined {
    if (!backofficeSubscriber) {
      return undefined;
    }

    return {
      subscriberId: backofficeSubscriber.id as SubscriberId,
      myVoltalisAccess: SubscriberMapper.fromBackofficeMyVoltalisAccessToDomain(backofficeSubscriber.myVoltalis),
      firstname: backofficeSubscriber.firstname,
      lastname: backofficeSubscriber.lastname,
      mails: backofficeSubscriber.mails.map(this.fromBackofficeMailToDomain),
      phones: backofficeSubscriber.phones.map(this.fromBackofficePhoneToDomain),
      company: !backofficeSubscriber.company
        ? undefined
        : {
            id: backofficeSubscriber.company.id as SubscriberCompanyId,
            corporateName: backofficeSubscriber.company.corporateName ?? undefined,
            fullName: backofficeSubscriber.company.fullName ?? undefined,
            name: backofficeSubscriber.company.name ?? undefined,
          },
      flags: backofficeSubscriber.flags,
    } satisfies Subscriber;
  }

  fromBackofficeMyVoltalisAccessToDomain(
    backofficeMyVoltalisAccess: SubscriberReadModel["myVoltalis"],
  ): SubscriberMyVoltalisAccess | undefined {
    if (!backofficeMyVoltalisAccess?.access) {
      return undefined;
    }

    switch (backofficeMyVoltalisAccess.access) {
      case "MY_VOLTALIS_2016":
        return SubscriberMyVoltalisAccess.MY_VOLTALIS_2016;
      case "MY_VOLTALIS_2022":
        return SubscriberMyVoltalisAccess.MY_VOLTALIS_2022;
    }

    return undefined;
  }
}

export const SubscriberMapper = new SubscriberMapperCls();
